import React from "react";
import { Modal , Popconfirm, theme, Tooltip } from "antd";
import { URL_TRUCK } from "../../../constants/urls";
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleFilled,
} from "@ant-design/icons";
import ErrorMessages from "../../../common/ErrorMessages";
import ColorButton from "../../../common/ColorButton";
import TSTable from "../../../common/TSTable";
import { dateToHumanString } from "../../../frameworks/Util";
import _ from "lodash";
import { DELETE } from "../../../frameworks/HttpClient";
import SellVehicleModal from "./SellVehicleModal";
import CustomDeleteConfirmButton from "../../../common/CustomDeleteConfirmButton";

export default function SellSupplierVehicleModal(props) {
  const { open, onClose, target } = props;
  const tableRef = React.useRef();
  const [errorMessages , setErrorMessages] = React.useState(null);
  const [vehicleTarget, setVehicleTarget] = React.useState(null);
  const { token : { colorSuccess, colorWarning }} = theme.useToken();

  const handleDelete = async (id) => {
    if (!id) {
      return;
    }
    setErrorMessages(null);
    try {
      await DELETE(`${URL_TRUCK.VEHICLE}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages (error.errorMessages);
    }
  };

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessages (error.errorMessages);
      }
    }
  };

  const handleEdit = (record) => {
    if (!record || !record.id) {
      return;
    }
    setVehicleTarget(record);
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 130,
      key: "action",
      align: "center",
      render: (_, record) =>
        (
          <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
            <Tooltip triger='hover' title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
                style={{ margin : 5}}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: 'ทะเบียนรถ',
      dataIndex: 'license_plate',
      key: 'license_plate',
    },
    {
      title: 'จังหวัด',
      dataIndex: 'province_name',
      key: 'province_name',
    },
    {
      title: 'ประเภทรถ',
      dataIndex: 'type_name',
      key: 'type_name',
    },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created',
      key: 'created',
      render : (value) => value ? dateToHumanString(value) : '-'
    },
  ]

  React.useEffect(() => {
    if(open && tableRef.current){
      tableRef.current.fetchData();
    }
  },[open])

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return(
    <Modal
      title={`รถน้ำยาง [${_.get(target, 'name', '-')}]`}
      open={open}
      onCancel={onClose}
      width={1000}
      destroyOnClose
      footer={[
        <ColorButton 
          onClick={onClose}
        >
          ปิด
        </ColorButton>,
      ]}
    >
      <ErrorMessages message={errorMessages} />
      <ColorButton
          type="primary"
          override={colorSuccess}
          icon={<PlusCircleFilled />}
          style={{ marginBottom: 10, float: "right" }}
          onClick={() => setVehicleTarget('add')}
        >
        เพิ่มรถน้ำยางสด
      </ColorButton>
      <TSTable
        ref={tableRef}
        columns={columns}
        size="small"
        url={URL_TRUCK.VEHICLE}
        params={{ supplier: _.get(target, 'id', '') }}
      />
      <SellVehicleModal
        open={vehicleTarget ? true : false}
        onClose={() => {
          setVehicleTarget(null);
        }}
        onUpdate={() => {
          setVehicleTarget(null);
          refreshData();
        }}
        target={vehicleTarget}
        supplier={target}
      />
    </Modal>

  )
}